import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Logo from "./Logo/Logo";
import Menu from "./Menu/Menu";
import Auth from "./Auth/Auth";
import Sidebar from "../SideDrawer/Sidebar";
import "./Nav.scss";

function Nav() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const nav = document.querySelector(".nav");
    const navHeight = nav.scrollHeight;

    const handleScroll = () => {
      const scrollHeight = window.pageYOffset;
      setIsSticky(scrollHeight > 200 ? true : false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav id="navbar" className={clsx("nav", isSticky ? "nav__sticky" : "")}>
      <div className="container-middle">
        <div className="nav__content">
          <Logo />
          <Sidebar />
          <Menu />
          <Auth />
        </div>
      </div>
    </nav>
  );
}

export default Nav;
